import gpuCardForm from './metaData/gpuCardForm'

export default {
  gpuCardCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: gpuCardForm,
      props
    })
  }
}
